export default __webpack_public_path__ + "static/media/phone.42c36a85.png";